import { Stack, useTheme } from "@mui/material";
import { ServiceFeeState } from "@/global/store/data/purchaseSeats/serviceFee";
import { CreditSubtotals } from "./CreditSubtotals";
import { ServiceFeeSubtotals } from "./ServiceFeeSubtotals";
import { TotalAmountWithBreakdown } from "./TotalAmountWithBreakdown";

export interface CheckoutSubtotalsV3Props {
  // values
  basePrice: number;
  allInPrice: number;
  perkTotalPrice: number;
  creditToBeApplied: number;
  amountDue: number;
  remainingCredit: number;
  processingFee: number;
  cartOrderServiceFee: number;
  totalAmountBreakdown?: ServiceFeeState["totalAmountBreakdown"];

  // logics
  isTotalAmountBreakdownEnabled?: boolean;
  isCreditEnabled?: boolean;
}

export function CheckoutSubtotalsV3(props: CheckoutSubtotalsV3Props) {
  const theme = useTheme();

  const {
    basePrice,
    allInPrice,
    perkTotalPrice,
    creditToBeApplied,
    amountDue,
    remainingCredit,
    processingFee,
    cartOrderServiceFee,
    totalAmountBreakdown,
    isTotalAmountBreakdownEnabled,
    isCreditEnabled,
  } = props;

  return (
    <Stack p={2} bgcolor={theme.palette.grey[100]} borderRadius={1.5}>
      {!isTotalAmountBreakdownEnabled ? (
        <ServiceFeeSubtotals
          basePrice={basePrice}
          allInPrice={allInPrice}
          perkTotalPrice={perkTotalPrice}
          cartOrderServiceFee={cartOrderServiceFee}
          processingFee={processingFee}
        />
      ) : null}

      {isTotalAmountBreakdownEnabled ? (
        <TotalAmountWithBreakdown
          totalAmountBreakdown={totalAmountBreakdown}
          allInPrice={allInPrice}
        />
      ) : null}

      {isCreditEnabled ? (
        <CreditSubtotals
          creditToBeApplied={creditToBeApplied}
          amountDue={amountDue}
          remainingCredit={remainingCredit}
        />
      ) : null}
    </Stack>
  );
}
